<template>
 <div>
    <relationship-update
      :ams_type="ams_type"
      :response_data="response_data"
      :response_included="response_included"
      @updateRelationship="resetRelationship"
      @descriptionUpdate="setDescription"
    ></relationship-update>
   <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card bg-variant="light">
          <div v-show="showPrimarySelection">
            Primary
            <interest-select id="header-id-primary-interest-id" @selectedItems="setPrimaryId" select_table_heading="Primary Interest Selection"/>
          </div>
          <div v-show="showSecondarySelection" >
            Secondary
            <interest-select id="header-id-secondary-interest-id" @selectedItems="setSecondaryId" select_table_heading="Secondary Interest Selection"/>
          </div>
          <div v-show="showTertiarySelection" >
            Tertiary
            <interest-select id="header-id-tertiary-interest-id" @selectedItems="setTertiaryId" select_table_heading="Tertiary Interest Selection"/>
          </div>
          <b-form-group 
            label-cols-lg="3"
            label="Collection"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >
            <b-form-group
              label="Name:"
              label-for="nested-name"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input id="nested-name"
                v-model="attr_copy.name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Access Permission:"
              label-cols-sm="3"
              label-align-sm="right"
              class="mb-0"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                class="pt-2"
                :options="['private_access', 'protected_access', 'public_access']"
                :aria-describedby="ariaDescribedby"
                v-model="attr_copy['access-permission']"
              ></b-form-radio-group>
            </b-form-group>
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import DataOperations from './DataOperations.vue'
import InterestSelect from './InterestSelect.vue'
import RelationshipUpdate from './RelationshipUpdate.vue'

export default {
  components: {
    DataOperations,
    InterestSelect,
    RelationshipUpdate
  },
  props: {
    id: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: 'collections',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      reassigned: false,
      primary_interest_name: '',
      secondary_interest_name: '',
      tertiary_interest_name: '',
      response_data: undefined,
      response_included: undefined
    }
  },
  computed: {
    // computedDescription() {
    //   return (this.description || (this.primary_interest_name + " & " + this.secondary_interest_name + " & " + this.tertiary_interest_name))
    // },
    showPrimarySelection() {
      return !(this.attr_copy['primary-interest-id'])
    },
    showSecondarySelection() {
      return !(this.attr_copy['secondary-interest-id'])
    },
    showTertiarySelection() {
      return !(this.attr_copy['tertiary-interest-id'])
    },
    canUpdate() {
      return (
        this.modified &&
        (this.attr_copy["primary-interest-id"]?.length > 0 || this.attr_copy["primary-interest-id"] > 0) &&
        (this.attr_copy["secondary-interest-id"]?.length > 0 || this.attr_copy["secondary-interest-id"] > 0) &&
        (this.attr_copy["secondary-interest-id"]?.length > 0 || this.attr_copy["secondary-interest-id"] > 0) &&
        this.attr_copy["name"]?.length > 0
      )
    },
    canDelete() {
      return true
    },
    canHelp() {
      return true
    }
  },
  methods: {
    jumpToId(id) {
      const element = document.getElementById(id)
      if(element) {
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
      } else {
        window.console.log( "could not find document element by id: " + id)
      }
    },
    resetRelationship(item) {
      window.console.log('resetRelationship for ' + item)
      this.attr_copy[item] = null
      this.jumpToId("header-id-" + item)
    },
    setDescription(description) {
      this.description = description
    },
    setPrimaryId(items) {
      this.attr_copy['primary-interest-id'] = items[0].id
      this.primary_interest_name = items[0].attributes['name']
    },
    setSecondaryId(items) {
      this.attr_copy['secondary-interest-id'] = items[0].id
      this.secondary_interest_name = items[0].attributes['name']
    },
    setTertiaryId(items) {
      this.attr_copy['tertiary-interest-id'] = items[0].id
      this.tertiary_interest_name = items[0].attributes['name']
    },
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      http_v1.delete (
        this.apiResourcePath()
      ).then(response => {
        if( response.status == 204) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.patch (
         this.apiResourcePath(), {
          ...attr_params
        }
      ).then(() => {
        this.$router.go(-1)
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.attr_copy = Object.assign( {}, response.data.data.attributes)
        this.attr_orig = Object.assign( {}, response.data.data.attributes)
        this.response_data = response.data.data
        this.response_included = response.data.included
        this.$emit('gotAttrs', this.attr_copy, this.response_data.attributes['name'])
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>